import {inject, Injectable} from '@angular/core';
import {GraphHumanumAuthorizationService} from '@modules/graph-humanum/core/services/graph-humanum-authorization.service';

@Injectable({
  providedIn: 'root'
})
export class GraphHumanumInitService {

    private graphHumanumAuthorizationService = inject(GraphHumanumAuthorizationService);

    initialize(){
        this.graphHumanumAuthorizationService.activeRulesOnStartup();
    }

}
